export const normalizeOpenPawnValues = values => {
    const source = Array.isArray(values) ? values : [values];
    const normalized = source
        .map(value => Number(value))
        .filter(value => Number.isInteger(value) && value >= 1 && value <= 6);
    const unique = [...new Set(normalized)];
    return unique.length ? unique.slice(0, 2) : [1, 6];
};

export const canOpenPawnWith = (values, rolledNumber) => {
    return normalizeOpenPawnValues(values).includes(Number(rolledNumber));
};

export const describeOpenPawnRule = values => {
    const normalized = normalizeOpenPawnValues(values);
    if (normalized.length === 1) return `Open pawn on ${normalized[0]}`;
    return `Open pawn on ${normalized.join(' or ')}`;
};
